// src/pages/Gallery.jsx
import React, { useEffect, useState, useCallback } from "react";
import "./gallery.css";

const FILE_COUNT = 26;

// pliki: public/gallery/01.jpg ... 26.jpg
const base = process.env.PUBLIC_URL || "";
const files = Array.from({ length: FILE_COUNT }, (_, i) => {
    const num = String(i + 1).padStart(2, "0");
    return `${base}/gallery/${num}.jpg`;
});

export default function Gallery() {
    const [isOpen, setIsOpen] = useState(false);
    const [idx, setIdx] = useState(0);

    const open = useCallback((i) => { setIdx(i); setIsOpen(true); }, []);
    const close = useCallback(() => setIsOpen(false), []);
    const prev = useCallback(() => setIdx((i) => (i - 1 + files.length) % files.length), []);
    const next = useCallback(() => setIdx((i) => (i + 1) % files.length), []);

    // Tytuł strony (bez Helmet)
    useEffect(() => {
        const prevTitle = document.title;
        document.title = "Galeria – Nierówno Pod Sufitem";
        return () => { document.title = prevTitle; };
    }, []);

    // Klawiatura: Esc / ← / →
    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => {
            if (e.key === "Escape") close();
            if (e.key === "ArrowLeft") prev();
            if (e.key === "ArrowRight") next();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [isOpen, close, prev, next]);

    // Zablokuj scroll tła, gdy lightbox otwarty
    useEffect(() => {
        if (!isOpen) return;
        const { body } = document;
        const prevOverflow = body.style.overflow;
        body.style.overflow = "hidden";
        return () => { body.style.overflow = prevOverflow; };
    }, [isOpen]);

    return (
        <>
            {/* pełnoekranowa sekcja strony Galeria (bez id pod kotwicę — to już podstrona) */}
            <section className="gallery" aria-label="Galeria zdjęć">
                <div className="gallery-inner">
                    <h2>GALERIA</h2>
                    <div className="grid" role="list">
                        {files.map((src, i) => (
                            <figure key={src} className="tile" role="listitem">
                                <img
                                    src={src}
                                    alt={`Galeria: zdjęcie ${i + 1} z ${files.length}`}
                                    loading="lazy"
                                    decoding="async"
                                    onClick={() => open(i)}
                                    className="tile-img"
                                />
                            </figure>
                        ))}
                    </div>
                </div>
            </section>

            {/* LIGHTBOX */}
            {isOpen && (
                <div
                    className="lb-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-label={`Podgląd zdjęcia ${idx + 1} z ${files.length}`}
                    onClick={close}
                >
                    <button
                        type="button"
                        className="lb-btn lb-prev"
                        aria-label="Poprzednie zdjęcie"
                        onClick={(e) => { e.stopPropagation(); prev(); }}
                    >
                        ‹
                    </button>

                    <div
                        className="lb-stage"
                        onClick={(e) => e.stopPropagation()}
                        role="group"
                        aria-roledescription="podgląd obrazu"
                    >
                        <img
                            src={files[idx]}
                            alt={`Galeria: zdjęcie ${idx + 1} z ${files.length}`}
                            className="lb-img"
                        />
                    </div>

                    <button
                        type="button"
                        className="lb-btn lb-next"
                        aria-label="Następne zdjęcie"
                        onClick={(e) => { e.stopPropagation(); next(); }}
                    >
                        ›
                    </button>

                    <button
                        type="button"
                        className="lb-close"
                        aria-label="Zamknij podgląd"
                        onClick={(e) => { e.stopPropagation(); close(); }}
                    >
                        ✕
                    </button>
                </div>
            )}
        </>
    );
}
